<template>
  <div class='title'>
    <h3>{{ title }}</h3>
  </div>
</template>

<script>
export default {
  name: 'create-title',
  props: {
    title: String
  }
}
</script>

<style scoped>
.title {
  margin-top: 4em;
}

</style>



// WEBPACK FOOTER //
// src/components/common/CreateTitle.vue